<script lang="ts">import { stateUi } from "@infinitro/config";
let { width = "", height = "", customStyles = "", customStylesCard = "", customStylesCardContent = "", customClass = "", highlight = false, opacity = 1, fullWidthMobile = false, glowColor = "var(--color-secondary-500)", noPadding = false, borderRadius: borderRadiusProp = "16px", withoutBorder = true, withoutOverflowHidden = false, flatBackground = false, flatBackgroundColor = "", noBorders = false, liquidGlassStyle = false, backgroundImage = true, noShadow = false, radialGradient2GlowStartColor = "rgba(255, 255, 255, 0.1)", radialGradient2BeforeTopColor = "var(--color-secondary-300)", noRadialGradient2Before = false, modernStyle = false, modernBordered = true, modernGlowPosition = "center", modernBorderColor = "var(--color-text-700)", modernGlowColor = "var(--color-primary-500)", modernGlowOpacity = .7, modernGlowSize = "", modernNoGlow = false, children } = $props();
const useModern = $derived(modernStyle || $stateUi.infoCard?.infoCardStyle === "modern");
const useSolid = $derived(!useModern && $stateUi.infoCard?.infoCardStyle === "solid");
const useSolidNeutral = $derived(!useModern && $stateUi.infoCard?.infoCardStyle === "solid-neutral");
const useRadialGradient2 = $derived(!useModern && $stateUi.infoCard?.infoCardStyle === "radial-gradient-2");
const useSolidDark = $derived(!useModern && $stateUi.infoCard?.infoCardStyle === "solid-dark");
const flatSurfaceColorResolved = $derived(flatBackgroundColor.trim() !== "" ? flatBackgroundColor.trim() : "");
const useFlatSurface = $derived(flatSurfaceColorResolved !== "");
const borderRadius = $derived(useRadialGradient2 ? "12px" : borderRadiusProp);
const mobileOpacityStyles = $derived(`--opacity: ${opacity};`);
const borderRadiusStyles = $derived(`--border-radius: ${borderRadius};`);
const radialGradient2GlowStart = $derived(`--info-card-radial-gradient-2-glow-start: ${radialGradient2GlowStartColor};`);
const radialGradient2BeforeTop = $derived(`--info-card-radial-gradient-2-before-top: ${radialGradient2BeforeTopColor};`);
const flatSurfaceStyles = $derived(useFlatSurface ? `--info-card-flat-surface: ${flatSurfaceColorResolved};` : "");
const modernGlowSizeResolved = $derived(modernGlowSize.trim() !== "" ? modernGlowSize.trim() : "50%");
const modernStyles = $derived(useModern ? `--info-card-modern-border-color: ${modernBorderColor}; --info-card-modern-glow-color: ${modernGlowColor}; --info-card-modern-glow-opacity: ${modernGlowOpacity}; --info-card-modern-glow-size: ${modernGlowSizeResolved};` : "");
const hideBackgroundImage = $derived(($stateUi.infoCard?.hideBackgroundImage ?? false) || useRadialGradient2 || useSolidDark || useSolidNeutral || useFlatSurface || useModern);
</script>

<div
	class:info-card-container={!liquidGlassStyle}
	class:info-card-container-glass={liquidGlassStyle}
	class={customClass + ' ' + (fullWidthMobile ? 'full-width-mobile' : '')}
	class:no-borders-chrome={noBorders}
	class:info-card-background-image={!hideBackgroundImage && backgroundImage}
	class:info-card-unset-background-image={hideBackgroundImage}
	style="position: relative; width: {width}; height: {height}; {mobileOpacityStyles} {borderRadiusStyles} {radialGradient2GlowStart} {radialGradient2BeforeTop} {flatSurfaceStyles} {modernStyles} {customStyles};"
>
	<div
		class:info-card-solid={useSolid || useSolidDark || useSolidNeutral}
		class:info-card-radial-gradient-2={useRadialGradient2}
		class:info-card-solid-dark={useSolidDark}
		class:info-card-solid-neutral={useSolidNeutral}
		class:info-card={!liquidGlassStyle}
		class:info-card-glass={liquidGlassStyle}
		class="{highlight || useModern ? '' : liquidGlassStyle ? '' : 'common'} {withoutBorder &&
			'common-without-border'} {withoutOverflowHidden ? 'with-overflow' : ''}"
		class:no-borders-chrome={noBorders}
		class:flat-background={flatBackground && !useFlatSurface}
		class:flat-surface={useFlatSurface}
		class:glass-background={liquidGlassStyle}
		class:no-shadow={noShadow}
		class:no-radial-gradient-2-before={(noRadialGradient2Before || useFlatSurface) &&
			useRadialGradient2}
		class:info-card-modern={useModern}
		class:info-card-modern-bordered={useModern && modernBordered}
		class:info-card-modern-no-glow={useModern && modernNoGlow}
		class:glow-left={useModern && !modernNoGlow && modernGlowPosition === 'left'}
		class:glow-center={useModern && !modernNoGlow && modernGlowPosition === 'center'}
		class:glow-right={useModern && !modernNoGlow && modernGlowPosition === 'right'}
		class:glow-bottom={useModern && !modernNoGlow && modernGlowPosition === 'bottom'}
		style="{mobileOpacityStyles} box-shadow: {noBorders || useModern
			? 'none'
			: `0 0 8px ${highlight ? glowColor : 'transparent'}`}; {flatSurfaceStyles} {modernStyles} {customStylesCard}"
	>
		<div class="card-content {noPadding ? 'no-padding' : ''}" style={customStylesCardContent}>
			{#if children}
				{@render children()}
			{/if}
		</div>
	</div>
</div>

<style>
	.info-card-container {
		border-radius: var(--border-radius);
	}

	.info-card-background-image {
		background-image: var(--gradient-main);
	}

	.info-card-unset-background-image {
		background-image: unset !important;
	}

	.info-card-container-glass {
		border-radius: 20px;
		border-width: 2px;
		--tw-border-opacity: 1;
		border-color: rgb(169 169 169 / var(--tw-border-opacity, 1));
}

	.info-card {
		position: relative;
		height: 100%;
		width: 100%;
		overflow: hidden;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		background-image:
			linear-gradient(180deg, var(--color-tertiary-500) 0%, var(--color-background-100) 100%),
			linear-gradient(to bottom, var(--color-neutral-300), var(--color-tertiary-300));
		background-origin: border-box;
		background-clip: content-box, border-box;
		border: double 1px transparent;
		border-radius: var(--border-radius);
		z-index: 2;
}

	.info-card-glass {
		position: relative;
		z-index: 2;
		height: 100%;
		width: 100%;
		overflow: hidden;
		border-radius: var(--border-radius);
		background-origin: border-box;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		background-clip: content-box, border-box;
}

	.info-card-solid {
		border-radius: 8px;
		border-width: 0px;
		background-color: var(--color-tertiary-500);
		background-image: unset !important;
}

	.info-card-solid-dark {
		background-color: var(--color-tertiary-900);
}

	.info-card-solid-neutral {
		border-width: 1px;
		border-style: solid;
		border-color: var(--color-neutral-900);
		background-color: var(--color-background-500);
}

	.info-card-radial-gradient-2 {
		position: relative;
		border: none !important;
		border-radius: var(--border-radius);
		background-image: unset !important;
		background: radial-gradient(
			100% 100% at 0% 50%,
			var(--color-tertiary-300) 0%,
			var(--color-tertiary-700) 100%
		) !important;
		overflow: hidden;
		background-clip: padding-box !important;
		background-origin: padding-box !important;
	}

	.info-card-radial-gradient-2::before {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: var(--border-radius);
		padding: 1px;
		background: linear-gradient(
			180deg,
			var(--info-card-radial-gradient-2-before-top) 0%,
			transparent 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
	}

	.no-radial-gradient-2-before::before {
		content: none !important;
		display: none !important;
	}

	.info-card-radial-gradient-2 > * {
		position: relative;
		z-index: 2;
	}

	.card-content {
		position: relative;
		z-index: 10;
		height: 100%;
		width: 100%;
		padding: 1rem;
}

	.card-content::-webkit-scrollbar {
		background-color: transparent;
		width: 6px;
}

	.card-content::-webkit-scrollbar-track {
		background-color: transparent;
}

	.card-content::-webkit-scrollbar-thumb {
		border-radius: 0.25rem;
		background-color: var(--color-neutral-700);
		opacity: 0;
		-webkit-transition: opacity 0.3s ease;
		transition: opacity 0.3s ease;
}

	.card-content:hover::-webkit-scrollbar-thumb {
		opacity: 0.7;
	}

	.card-content::-webkit-scrollbar-thumb:hover {
		background-color: var(--color-neutral-600);
		opacity: 1;
}

	.card-content {
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	.card-content:hover {
		scrollbar-color: var(--color-neutral-700) transparent;
	}

	.no-padding {
		padding: 0px;
}

	.common {
		box-shadow: 0 0 0 2px var(--color-background-100) !important;
		background-image:
			linear-gradient(180deg, var(--color-tertiary-500) 0%, var(--color-background-100) 100%),
			linear-gradient(
				to top,
				var(--color-neutral-900) 0%,
				var(--color-neutral-900) 58%,
				rgba(255, 255, 255, 0.22) 100%
			);
	}

	.common-without-border {
		box-shadow: none !important;
	}

	.with-overflow {
		overflow: visible;
}

	.full-width-mobile {
		min-width: 100%;
}

	@media (min-width: 1024px) {
		.full-width-mobile {
				min-width: 0px;
		}
	}

	@media screen and (max-width: 768px) {
		/* FALLBACK FOR OLDER BROWSERS WITH NO COLOR-MIX */
		.info-card-background-image {
			background-image: linear-gradient(
				to bottom,
				var(--color-tertiary-500),
				var(--color-background-100)
			);
			background-image: linear-gradient(
				to bottom,
				color-mix(in srgb, var(--color-tertiary-500) calc(var(--opacity, 1) * 100%), transparent),
				color-mix(in srgb, var(--color-background-100) calc(var(--opacity, 1) * 100%), transparent)
			);
		}

		/* FALLBACK FOR OLDER BROWSERS WITH NO COLOR-MIX */
		.info-card {
			background-image:
				linear-gradient(to bottom, var(--color-tertiary-500), var(--color-background-100)),
				linear-gradient(to bottom, var(--color-neutral-300), var(--color-tertiary-300));
			background-image:
				linear-gradient(
					to bottom,
					color-mix(in srgb, var(--color-tertiary-500) calc(var(--opacity, 1) * 100%), transparent),
					color-mix(
						in srgb,
						var(--color-background-100) calc(var(--opacity, 1) * 100%),
						transparent
					)
				),
				linear-gradient(
					to bottom,
					color-mix(in srgb, var(--color-neutral-300) calc(var(--opacity, 1) * 100%), transparent),
					color-mix(in srgb, var(--color-tertiary-300) calc(var(--opacity, 1) * 100%), transparent)
				);
		}

		/* FALLBACK FOR OLDER BROWSERS WITH NO COLOR-MIX */
		.common {
			background-image:
				linear-gradient(to bottom, var(--color-tertiary-500), var(--color-background-100)),
				linear-gradient(
					to top,
					var(--color-neutral-900) 0%,
					var(--color-neutral-900) 58%,
					rgba(255, 255, 255, 0.22) 100%
				);
			background-image:
				linear-gradient(
					to bottom,
					color-mix(in srgb, var(--color-tertiary-500) calc(var(--opacity, 1) * 100%), transparent),
					color-mix(
						in srgb,
						var(--color-background-100) calc(var(--opacity, 1) * 100%),
						transparent
					)
				),
				linear-gradient(
					to top,
					color-mix(in srgb, var(--color-neutral-900) calc(var(--opacity, 1) * 100%), transparent)
						0%,
					color-mix(in srgb, var(--color-neutral-900) calc(var(--opacity, 1) * 100%), transparent)
						58%,
					rgba(255, 255, 255, 0.22) 100%
				);
		}
	}

	.flat-background {
		background-image:
			linear-gradient(180deg, var(--color-tertiary-500) 0%, var(--color-tertiary-500) 100%),
			linear-gradient(
				to top,
				var(--color-neutral-900) 0%,
				var(--color-neutral-900) 58%,
				rgba(255, 255, 255, 0.22) 100%
			);
	}

	.glass-background {
		isolation: isolate;
		border-radius: 20px;
		--tw-backdrop-blur: blur(15px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		background: rgba(255, 255, 255, 0.1);
}

	.no-shadow {
		box-shadow: none !important;
		filter: none !important;
		backdrop-filter: none !important;
		-webkit-backdrop-filter: none !important;
	}

	.no-shadow::before,
	.no-shadow::after {
		content: none !important;
	}

	.flat-surface {
		background: var(--info-card-flat-surface) !important;
		background-image: none !important;
		border: none !important;
		box-shadow: none !important;
		background-clip: border-box !important;
		background-origin: border-box !important;
	}

	.flat-surface::before,
	.flat-surface::after {
		content: none !important;
		display: none !important;
	}

	.no-borders-chrome.info-card-container,
	.no-borders-chrome.info-card-container-glass {
		border: none !important;
		outline: none !important;
		box-shadow: none !important;
		background-image: none !important;
	}

	.no-borders-chrome.info-card,
	.no-borders-chrome.info-card-solid,
	.no-borders-chrome.info-card-solid-dark,
	.no-borders-chrome.info-card-radial-gradient-2,
	.no-borders-chrome.info-card-glass,
	.no-borders-chrome.info-card-modern {
		border: none !important;
		outline: none !important;
		box-shadow: none !important;
	}

	.info-card-modern {
		position: relative;
		background-color: var(--color-background-900) !important;
		background-image: none !important;
		border-width: 1px;
		border-style: solid;
		border-color: transparent;
	}

	.info-card-modern.info-card-modern-bordered {
		border-color: var(--info-card-modern-border-color, var(--color-text-700));
	}

	.info-card-modern::before {
		content: '';
		position: absolute;
		width: var(--info-card-modern-glow-size, 50%);
		min-width: 250px;
		aspect-ratio: 1 / 1;
		border-radius: 50%;
		background: radial-gradient(
			circle,
			var(--info-card-modern-glow-color, var(--color-primary-500)) 0%,
			transparent 70%
		);
		opacity: var(--info-card-modern-glow-opacity, 0.7);
		pointer-events: none;
		z-index: 0;
	}

	.info-card-modern-no-glow::before {
		content: none;
	}

	.info-card-modern.glow-left::before {
		top: 0;
		left: 0;
		transform: translate(-50%, -50%);
	}

	.info-card-modern.glow-center::before {
		top: 0;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.info-card-modern.glow-right::before {
		top: 0;
		right: 0;
		transform: translate(50%, -50%);
	}

	.info-card-modern.glow-bottom::before {
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 50%);
	}

	@media screen and (max-width: 768px) {
		.flat-surface {
			background: var(--info-card-flat-surface) !important;
			background-image: none !important;
		}
	}
</style>
